module.exports = __webpack_public_path__ + "pointsrelais-pin.png";